import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import CommentsSection from "../CommentsSection";
import "./Modal.css";

// Standalone host for a guide-level comment thread ("Should we reschedule
// to Oct 23?", "Can we include a spa day?") — CommentsSection is otherwise
// always embedded inside a Place/Event editor; this is its one
// not-attached-to-anything-specific home, opened from the Guide menu's
// always-visible "Trip Discussion" entry (not gated on comment_count, since
// someone has to be able to post the very first comment) and from the
// comments jump-list's own "Trip Discussion" row, if it has any yet.
class GuideDiscussionModal extends Component {
  render() {
    return (
      <div className="modal">
        <Modal {...this.props} size="md" aria-labelledby="contained-modal-title-vcenter" centered scrollable={true}>
          <Modal.Header>
            <div style={{ width: "100%" }}>
              <div className="dialog-heading">
                <div>
                  <h4 style={{ color: "#3598DB" }}>Trip Discussion</h4>
                </div>
                <div>
                  <FontAwesomeIcon
                    icon={solid("times")}
                    className="pointer color-blue"
                    onClick={() => this.props.onHide()}
                  ></FontAwesomeIcon>
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <CommentsSection targetType="guide" />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default GuideDiscussionModal;
